export default __webpack_public_path__ + "static/media/cloud-download.2642c613.svg";